// src/hooks/usePulsatingOutline.jsx
import {useState, useEffect, useRef} from 'react';
import {gsap} from 'gsap';

// Default settings (can be overridden)
const DEFAULT_INITIAL_THICKNESS = 0.01;
const DEFAULT_MAX_THICKNESS = 0.03;
const DEFAULT_DURATION = 1.0; // Duration of one pulse cycle (thicker -> thinner)

export function usePulsatingOutline(
    initialThickness = DEFAULT_INITIAL_THICKNESS,
    maxThickness = DEFAULT_MAX_THICKNESS,
    duration = DEFAULT_DURATION
) {
    const [thickness, setThickness] = useState(initialThickness);
    const tweenRef = useRef(null); // To store the GSAP tween

    useEffect(() => {
        // Use a temporary object for GSAP to tween
        const target = {value: initialThickness};

        // Create the repeating tween
        tweenRef.current = gsap.to(target, {
            value: maxThickness,
            duration: duration,
            ease: 'sine.inOut', // Smooth pulse
            yoyo: true,        // Go back and forth
            repeat: -1,        // Repeat indefinitely
            onUpdate: () => {
                // Update the state on each tween update
                setThickness(target.value);
            },
        });

        // Cleanup function to kill the tween on unmount
        return () => {
            if (tweenRef.current) {
                tweenRef.current.kill();
                tweenRef.current = null;
            }
        };
        // Re-run effect if parameters change (optional, usually not needed for constant pulsing)
    }, [initialThickness, maxThickness, duration]);

    return thickness; // Return the current thickness value
}